import template from './number.pug';

export const NumberComponent = {
  template,
  bindings: {
    label: '@?',
    description: '@?',
    model: '<',
    validations: '<?',
    placeholder: '<?',
    onEdit: '&?',
  },
  transclude: true,
  controller: class NumberComponent {
    constructor() {
      'ngInject';
      this.debounce = 500;
    }

    $onInit() {
      if ( this.model && (typeof this.model === 'string')) {
        this.model = Number(this.model);
      }
    }

    edit(number) {
      this.onEdit({
        $event: { number }
      });
    }

  }
};
